/** Laden, Leer und Fehler an einem Ort, damit jeder Bildschirm dieselben drei hat. */

export function Laden({ text = 'Wird geladen …' }) {
  return (
    <p class="zustand zustand--laden" role="status">
      {text}
    </p>
  )
}

export function Leer({ text, kind }) {
  return (
    <div class="zustand zustand--leer">
      <p>{text}</p>
      {kind}
    </div>
  )
}

export function Fehler({ fehler, erneut }) {
  return (
    <div class="zustand zustand--fehler" role="alert">
      <p>{fehler?.message || 'Etwas ist schiefgelaufen'}</p>
      {erneut ? (
        <button type="button" class="knopf knopf--still" onClick={erneut}>
          Erneut versuchen
        </button>
      ) : null}
    </div>
  )
}
